import React from 'react';

export const FaceSurprisedIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M15.9989 29.9978C25.3333 29.9978 29.9978 23.7303 29.9978 15.9989C29.9978 8.26751 25.3333 2 15.9989 2C6.66443 2 2 8.26751 2 15.9989C2 23.7303 6.66443 29.9978 15.9989 29.9978Z"
        fill="#FFB02E"
      />
      <path
        d="M10.5 19C12.9853 19 15 16.9853 15 14.5C15 12.0147 12.9853 10 10.5 10C8.01472 10 6 12.0147 6 14.5C6 16.9853 8.01472 19 10.5 19Z"
        fill="white"
      />
      <path
        d="M21.5 19C23.9853 19 26 16.9853 26 14.5C26 12.0147 23.9853 10 21.5 10C19.0147 10 17 12.0147 17 14.5C17 16.9853 19.0147 19 21.5 19Z"
        fill="white"
      />
      <path
        d="M12 17C13.1046 17 14 16.1046 14 15C14 13.8954 13.1046 13 12 13C10.8954 13 10 13.8954 10 15C10 16.1046 10.8954 17 12 17Z"
        fill="#402A32"
      />
      <path
        d="M20 17C21.1046 17 22 16.1046 22 15C22 13.8954 21.1046 13 20 13C18.8954 13 18 13.8954 18 15C18 16.1046 18.8954 17 20 17Z"
        fill="#402A32"
      />
      <path
        d="M6.97423 9.65811C7.11769 9.22774 7.47625 8.55049 8.06915 7.98761C8.65355 7.4328 9.45199 7 10.4999 7C10.776 7 10.9999 6.77614 10.9999 6.5C10.9999 6.22386 10.776 6 10.4999 6C9.1478 6 8.1129 6.5672 7.38064 7.26239C6.65687 7.94951 6.21542 8.77226 6.02555 9.34189C5.93823 9.60386 6.07981 9.88702 6.34178 9.97434C6.60375 10.0617 6.88691 9.92009 6.97423 9.65811Z"
        fill="#402A32"
      />
      <path
        d="M25.0255 9.65811C24.8821 9.22774 24.5235 8.55049 23.9306 7.98761C23.3462 7.4328 22.5478 7 21.4999 7C21.2237 7 20.9999 6.77614 20.9999 6.5C20.9999 6.22386 21.2237 6 21.4999 6C22.852 6 23.8869 6.5672 24.6191 7.26239C25.3429 7.94951 25.7844 8.77226 25.9742 9.34189C26.0616 9.60386 25.92 9.88702 25.658 9.97434C25.396 10.0617 25.1129 9.92009 25.0255 9.65811Z"
        fill="#402A32"
      />
      <path
        d="M21.8148 25.5152C22.0192 26.318 21.3284 27 20.4999 27C17.5404 27 14.7595 27 11.5005 27C10.6721 27 9.98074 26.318 10.1851 25.5152C10.8459 22.9196 13.1988 21 16 21C18.8012 21 21.1541 22.9196 21.8148 25.5152Z"
        fill="#BB1D80"
      />
    </svg>
  );
};
